const DUMMY_DATA = [
  {
    inactive: false,
    logoUrl: "",
    formatName: "",
    code: "",
    name: "",
    networkName: "",
    id: "",
    rank: 0,
    type: "",
    isFBAssest: false,
  },
];

const DUMMY_TRENDING_DATA = [
  {
    logoUrl: "https://cryptologos.cc/logos/1inch-1inch-logo.svg?v=025",
    type: "Crypto",
    code: "1INCH",
    name: "1inch (1INCH)",
    networkName: "Ethereum",
    inactive: false,
    id: "425",
    rank: 102,
    formatName: "ERC-20",
    isFBAsset: true,
  },
  {
    logoUrl: "https://cryptologos.cc/logos/akropolis-akro-logo.svg?v=025",
    inactive: false,
    id: "155",
    type: "Crypto",
    name: "Akropolis (AKRO)",
    formatName: "ERC-20",
    isFBAsset: true,
    rank: 3,
    networkName: "Ethereum",
    code: "AKRO",
  },
  {
    isFBAsset: true,
    type: "Crypto",
    logoUrl: "https://cryptologos.cc/logos/enjin-coin-enj-logo.svg?v=025",
    formatName: "ERC-20",
    code: "ENJ",
    inactive: false,
    id: "199",
    rank: 1,
    networkName: "Ethereum",
    name: "Enjin Coin (ENJ)",
  },
];

export const searchConstants = {
  dummyData: DUMMY_DATA,
  dummyTrendingData: DUMMY_TRENDING_DATA,
  placeholder: "Search",
  subtitle: "Cryptocurrencies",
  trendingSubtitle: "Trending searches 🔥",
  dataLimit: 10,
  errorMessage: "Only alphanumerical letters allowed",
};
